
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { AccessibilityButton } from "@/components/AccessibilityButton";
import {
  HeroSection,
  ConsultorioCard,
  OnlineConsultation,
  StatisticsSection
} from "@/components/Consultorios";
import { consultorios } from "@/data/consultorios";

export default function Consultorios() {
  // Função para fazer ligação
  const handleCall = (phone: string) => {
    window.open(`tel:${phone.replace(/\D/g, '')}`);
  };

  return (
    <>
      <div className="min-h-screen bg-white">
        <Header />

        <div className="pt-24">
        <HeroSection />

        {/* Consultórios */}
        <section className="py-16">
          <div className="container mx-auto px-6">
            <div className="space-y-12">
              {consultorios.map((consultorio, index) => (
              <ConsultorioCard
                key={consultorio.id}
                consultorio={consultorio}
                index={index}
                onCall={handleCall}
              />
              ))}
            </div>
          </div>
        </section>

        <OnlineConsultation />

        <StatisticsSection />
        </div>

        <Footer />
        <FloatingWhatsApp />
        <AccessibilityButton />
      </div>
    </>
  );
}
